import { AutotradeBotResponse } from "../../../api/autotrade-bots";

export function isBotArchived(bot: AutotradeBotResponse) {
  return bot.deleted_at !== null;
}

export function isBotActive(bot: AutotradeBotResponse) {
  return bot.deleted_at === null;
}